import generateNCPDetailUrl from '../generateNCPDetailUrl';

const generateNCPMenuBarList =  (slug) =>{
    return [
        {
          name: 'OVERVIEW',
          description: null,
          priority: 0,
          path: generateNCPDetailUrl(slug, ''),
        },
        {
          name: 'SPESIFIKASI',
          description: null,
          priority: 1,
          path: generateNCPDetailUrl(slug, 'spesifikasi'),
        },
        {
          name: 'INTERIOR',
          description: null,
          priority: 2,
          path: generateNCPDetailUrl(slug, 'interior'),
        },
        {
          name: 'EKSTERIOR',
          description: null,
          priority: 3,
          path: generateNCPDetailUrl(slug, 'eksterior'),
        },
        {
          name: 'LAINNYA',
          description: null,
          priority: 4,
          children: [
            {
              name: 'TIPE',
              description: null,
              priority: 5,
              path: generateNCPDetailUrl(slug, 'tipe'),
            },
            {
              name: 'WARNA',
              description: null,
              priority: 6,
              path: generateNCPDetailUrl(slug, 'warna'),
            },
            {
              name: 'KREDIT',
              description: null,
              priority: 7,
              path: generateNCPDetailUrl(slug, 'kredit'),
            },
            {
              name: 'ULASAN',
              description: null,
              priority: 8,
              path: generateNCPDetailUrl(slug, 'ulasan'),
            },
            {
              name: 'GALERI',
              description: null,
              priority: 9,
              path: generateNCPDetailUrl(slug, 'galeri'),
            },
            {
              name: 'VIDEO',
              description: null,
              priority: 10,
              path: generateNCPDetailUrl(slug, 'video'),
            },
          ],
        },
      ];
}

  export default generateNCPMenuBarList;